import { Arg, Metadata } from '../../../../../utils/spds/metadata';
import { on } from '@ember/modifier';
import FlexRow from '../../../layout/flex/row.gjs';
import GhostButton from '../../../action/button/ghost.gjs';
import PrimaryButton from '../../../action/button/primary.gjs';
import Super from '../../../core/base.gjs';

const METADATA = Metadata.define({
  description:
    'CTA button container for the alert banner message, supporting primary and secondary actions',
  meta: {
    onPrimaryBtnClick: Arg.action({
      description: 'Action triggered when the primary button is clicked',
    }),
    onSecondaryBtnClick: Arg.action({
      description: 'Action triggered when the secondary button is clicked',
    }),
    primaryBtnText: Arg.string({ description: 'Text label for the primary action button' }),
    secondaryBtnText: Arg.string({ description: 'Text label for the secondary action button' }),
  },
  name: 'Alert Banner Message CTA',
});

export default class SpdsFeedbackAlertBannerMessageCta extends Super {
  static metadata = this.setMetadata(METADATA, import.meta.url);
  baseClass = 'spds-feedback-alert-banner-message-cta';

  get primaryBtnId() {
    return this.composeSubcomponentId('primary-btn');
  }

  get secondaryBtnId() {
    return this.composeSubcomponentId('secondary-btn');
  }

  <template>
    <FlexRow
      class={{this.classes}}
      data-test-spds-feedback-alert-banner-message-cta
      {{this.validateArguments}}
      ...attributes
    >
      {{#if @onPrimaryBtnClick}}
        <PrimaryButton id={{this.primaryBtnId}} type="button" {{on "click" @onPrimaryBtnClick}}>
          {{@primaryBtnText}}
        </PrimaryButton>
      {{/if}}
      {{#if @onSecondaryBtnClick}}
        <GhostButton id={{this.secondaryBtnId}} type="button" {{on "click" @onSecondaryBtnClick}}>
          {{@secondaryBtnText}}
        </GhostButton>
      {{/if}}
    </FlexRow>
  </template>
}

export const ALERT_BANNER_MESSAGE_CTA_METADATA = SpdsFeedbackAlertBannerMessageCta.metadata;
